import React from 'react';
import { Box, TextV2, ButtonV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

interface HeaderLayoutUpgradeBannerProps
  extends Readonly<{
    onUpgrade: () => void;
  }> {}

const HeaderLayoutUpgradeBanner: React.FC<HeaderLayoutUpgradeBannerProps> = ({ onUpgrade }) => {
  const { tq } = useTranslation('headerLayoutUpgrade');

  return (
    <Box
      display="flex"
      backgroundColor="newUIBrandPrimary"
      width="100%"
      zIndex="banner"
      position="fixed"
      top={0}
      alignItems="center"
      justifyContent="center"
      paddingX={5}
      paddingY={4}
      gap={[4, null, 5]}
    >
      <TextV2
        typographyVariant="label3"
        color="white"
      >
        {tq`Your website is published without the video background`}
      </TextV2>
      <ButtonV2
        flexShrink={0}
        variant="outline"
        typographyVariant="label3"
        onClick={onUpgrade}
        color="white"
        borderColor="white"
        shape="rounded"
        _hover={{ color: 'white', borderColor: 'white' }}
        _active={{ color: 'white', borderColor: 'white' }}
      >
        {tq`Upgrade Now`}
      </ButtonV2>
    </Box>
  );
};

HeaderLayoutUpgradeBanner.displayName = 'HeaderLayoutUpgradeBanner';

export { HeaderLayoutUpgradeBanner };
